import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {deleteDocsList} from '../../../modules/admin/docs';
import styles from './styles/delete-modal.module.css';

import ButtonBox from '../ButtonBox';

export default function DeleteModal({ handleClose, reReadDocsList, itemToDelete = {}, itemsToDelete }) {
    const dispatch = useDispatch();

    const { deleteResponse, deleteLoading } = useSelector(({ docs, loading }) => ({
        deleteResponse: docs.deleteResponse,
        deleteLoading: loading['docs/DELETE_DOCS_LIST']
    }));

    const { type, name } = itemToDelete;

    const countToDelete = itemsToDelete.length;
        
    const handleDelete = () => {
        const deleteList = countToDelete > 1 ? itemsToDelete : [itemToDelete];

        const idList = deleteList.map((item) => ({
            id: item.id,
            type: item.type
        }));

        dispatch(deleteDocsList({ idList }));
    
    };
        
    useEffect(() => {
        if (!deleteLoading && deleteResponse) {
            handleClose();
            reReadDocsList();
        }
    }, [deleteLoading, deleteResponse]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.titleBox}>
                <p className={styles.title}>
                    {countToDelete > 1
                        ? `${countToDelete}개의 항목을 삭제할까요?`
                        : `해당 ${type === 'DOCS' ? '파일을' : '카테고리를'} 삭제할까요?`
                    }
                </p>
                {countToDelete > 1 ? null : <p className={styles.name}>{name}</p>}
            </div>
            <ButtonBox
                text='삭제'
                inactiveColor='#825DFC'
                activeColor='#825DFC'
                validateBtn={() => true}
                handleCancle={handleClose}
                handleClick={handleDelete}
                loading={deleteLoading}
            />
        </div>
    );
}
